<template>
    <div class="threeIcon">
        <div class="indexBg">
            <div class="indexContainer" >
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
                <div class="threeIconMain">
                    <el-row :gutter="20">
                        <el-col :span="8" v-for="(item, index) in data.attaches" :key="index">
                            <div @click="rowClick(item)">
                                <img :src="item.imgUrl" :alt="item.imgAlt">
                                <p class="title">{{item.title}}</p>
                                <p class="text">{{item.summary}}</p>
                            </div>
                        </el-col>
                    </el-row>    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    val: {}
  },
    data(){
        return{
          data: {},       
        }
    },
    created() {
      this.data = this.val;

    },
    methods:{
        rowClick(row){
            if(row.linkUrl){
                window.open(row.linkUrl, '_self');     
            }
        },
    },
    watch: {
      val(val) {
        this.data = this.val;
      }
    }
}
</script>
<style lang="less" scoped>
.threeIcon{
    .indexBg{
        background: #f7f7f7;
        width: 100%;
        .el-divider__text{
            background: #f7f7f7;
        }
    }
    .threeIconMain{
        padding: 10px 0;
       .el-col{
          padding: 0px;
          cursor: pointer;
       } 
       .title{
           font-size: 16px;
           margin: 10px 0;
       }
       .text{
          text-align:left;
          line-height: 24px;
          color: #808080;
            width: 100%;
            overflow: hidden;
            -webkit-line-clamp: 3;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
       }
       img{
           max-width: 50px;
           max-height: 50px;
       }
    }


    @media (min-width: 768px)  {
       
    .threeIconMain{
        .el-col{
            padding: 0 50px;
        } 
       .title{
           font-size: 18px;
           margin: 10px 0;
       }
        .text{
            line-height: 30px;
            -webkit-line-clamp: 3;
       }
    }

       
    }   
}
</style>


// WEBPACK FOOTER //
// src/components/item/patch25.vue